import { GetParcelSearchParameters } from '@lanterds/types';
import { baseUrl, genericNetworkErrorHandler } from '.';
import { AuthRequest, Method } from 'src/util/Request';

const postParcelsSearch = async (searchParams: Partial<GetParcelSearchParameters>) => {
    const headers = {
        'Content-Type': 'application/json',
    };
    const res = await AuthRequest(`${baseUrl}/parcelSearch/parcels`, Method.POST, headers, {
        ...searchParams,
        customerFmtpId: searchParams.customerId,
    });
    if (res.ok) {
        const parcels = await res.json();
        return parcels;
    } else {
        await genericNetworkErrorHandler(res);
    }
};

const getParcelDetails = async (barcode: string, date: Date, customerId: string, endpointName: string) => {
    const url = `${baseUrl}/parcelSearch/details/getDetailsByUniversalID?barcode=${barcode}&date=${new Date(
        date,
    ).toISOString()}&customerId=${customerId}&endpointName=${endpointName}`;
    const res = await AuthRequest(url, Method.GET);

    if (res.ok) {
        const details = await res.json();
        return details;
    } else {
        await genericNetworkErrorHandler(res);
    }
};

const parcel = {
    postParcelsSearch,
    getParcelDetails,
};

export default parcel;
